export const baseUrl = process.env.VUE_APP_BASE_URL;
// export const baseUrl = "https://daas.api.yxshoukang.com";
// export const websocketUrl = process.env.VUE_APP_BASE_URL.replace('http', 'ws') + "/websocket";

export function setToken(token) {
    if (token) {    
        sessionStorage.setItem("accessToken", token);
    } else {
        sessionStorage.removeItem("accessToken");
    }
}

export function get(url, callback, error) {
    fetch(url.startsWith("http") ? url : baseUrl + url, {
        method: "GET",
        headers: {
            "content-type": "application/json",
            "Access-Token": sessionStorage.getItem("accessToken")
        }
    }).then(res => {
        res.json().then(data => {
            callback(data, url)
        }).catch(res => {
            error(res)
        })
    }).catch(res => {
        error(res)
    })
}

export function post(url, data, callback, error) {
    fetch(url.startsWith("http") ? url : baseUrl + url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Access-Token": sessionStorage.getItem("accessToken")
        },
        body: JSON.stringify(data)
    }).then(res => {
        res.json().then(data => {
            callback(data)
        }).catch(res => {
            error(res)
        })
    }).catch(res => {
        error(res);
    })
}